import { Component, signal, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './components/sidebar/sidebar';
import { HeaderComponent } from './components/header/header';
import { ToastComponent } from './components/toast/toast';
import { DevProdSyncModalComponent } from './components/dev-prod-sync-modal/dev-prod-sync-modal';
import { DevProdSyncModalStateService } from './core/services/dev-prod-sync-modal';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, ToastComponent, DevProdSyncModalComponent, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('Discont');
  isLoginRoute = true;
  protected readonly devProdSyncModal = inject(DevProdSyncModalStateService);
  private router = inject(Router);

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      const url = (event?.urlAfterRedirects || '') as string;
      this.isLoginRoute = url.includes('/login') || url.startsWith('/change-password');
    });
  }
}

